<template>
  <div
    class="s-overall-settings"
    :id="rendering?.dataSource"
    :class="rootClasses"
    :style="themeStyle"
    v-if="fields"
    v-show="$appVisible($route, fields)"
    ref="rootEl"
  >
    <slot />
  </div>
</template>

<script>
import { computed, inject, nextTick, onBeforeUnmount, onMounted, reactive, toRefs } from 'vue';
import { overallSettingClasses, settingValue } from '@/utils/site-utils';
import BUS_EVENTS from '@/utils/bus-events';
import { sitecoreProps } from '@/utils/constants';
import { getQueryStrings } from '@/utils/uri-utils';
import { getOffsetTop } from '@/utils/dom-utils';

export default {
  name: 'OverallSettings',
  props: {
    /**@type OverallSettingFields*/
    fields: {
      type: Object,
    },
    page: {
      type: Object,
    },
    rendering: {
      type: Object,
    },
    ...sitecoreProps,
  },
  setup(props) {
    if (!props.fields) return;
    const $bus = inject('$bus');
    const state = reactive({
      rootEl: null,
    });
    const computes = {
      rootClasses: computed(() => [...overallSettingClasses(props)]),
      themeStyle: computed(() => ({
        backgroundColor: settingValue(props.fields?.backColor),
        color: settingValue(props.fields?.foreColor),
      })),
    };
    const methods = {
      onScroll() {
        if (!state.rootEl) return;
        const rect = state.rootEl.getBoundingClientRect();
        if (rect.top <= 0 && rect.bottom > 0) {
          $bus.emit(BUS_EVENTS.UPDATE_HEADER_THEME, settingValue(props.fields.headerTheme, null));
        }
      },
      scrollToSecondScreen(secondScreenId) {
        const secondScreen = document.getElementById(secondScreenId);
        if (secondScreen) {
          const offsetTop = getOffsetTop(secondScreen);
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });
        }
      },
    };
    onMounted(() => {
      const [secondScreenId] = getQueryStrings('id');
      if (secondScreenId) {
        nextTick(() => {
          setTimeout(() => {
            methods.scrollToSecondScreen(secondScreenId);
          }, 100);
        });
      }
      window.addEventListener('scroll', methods.onScroll);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', methods.onScroll);
    });
    return {
      ...toRefs(state),
      ...computes,
    };
  },
};
</script>

<style lang="scss">
@import '../styles/variables';
@import '../styles/functions';
@import '../styles/mixins';
.s-overall-settings {
  @include overall-settings;
  color: $black;
  position: relative;
  z-index: 1;
}
</style>
